// extracted by mini-css-extract-plugin
module.exports = {"modalChemical":"AddNewModal_modalChemical__3Q03X"};